"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
const _excluded = ["title", "description"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const bookmark = _ref => {
  let {
      title,
      description
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? "title-bookmark" : '') + (description ? " desc-bookmark" : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-bookmark"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-bookmark"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M21 0.25H3C2.58579 0.25 2.25 0.585786 2.25 1V23L2.25666 23.1029C2.33118 23.6702 3.01474 23.9595 3.47683 23.5789L12 16.557L20.5232 23.5789C21.0124 23.9819 21.75 23.6339 21.75 23V1C21.75 0.585786 21.4142 0.25 21 0.25ZM20.25 1.75V21.411L12.4768 15.008L12.3803 14.9405C12.1126 14.7827 11.7694 14.8053 11.5232 15.008L3.75 21.41V1.75H20.25Z",
    fill: "inherit"
  }));
};
var _default = exports.default = bookmark;